module.exports = __webpack_public_path__ + "img/kaspi.55abffc7.svg";